export default __webpack_public_path__ + "static/media/logoblancoColor.2eff2d06.png";